<template>
  <div class="exhibitors-add">
    <a-alert v-if="isShowCreateExhibitions&&isAllowCreateExnum" banner class="mb-16">
      <div slot="message">
        {{ $t('chooseBooth.no_search_booth_err') }}
        <span>
          {{ $t('chooseBooth.，可点击') }}
          <span
            class="red"
            @click="$router.push('/addBooth')"
          >{{ $t('chooseBooth.新增展位') }}</span>
        </span>
      </div>
    </a-alert>
    <div>
      <label class="mr-10">{{ $t('chooseBooth.company_label') }}:</label>
      <a-select :value="selectItem" :filter-option="filterOption" show-search style="width: 80%" @search="search" @change="handleChange">
        <a-select-option v-for="item in exhibitionsList" :key="item.exhibitor" :value="item.exhibitor">
          {{ item.exhibitor }}
        </a-select-option>
      </a-select>
    </div>
    <div v-if="exhibitionsItemList.length === 0&&isShowCreateExhibitions" class="mt-20" style="color:#a6a6a6;text-align: center;">{{ $t('shopList.暂无可添加展位') }}</div>
    <div v-else>
      <a-checkbox-group v-if="isShowCreateExhibitions" @change="exhibitionsItemChange">
        <div class="mt-20">
          <a-checkbox v-for="item in exhibitionsItemList" :key="item.id" :value="item.id" :disabled="item.bind">
            {{ item.exnum }}
          </a-checkbox>
        </div>
      </a-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exhibitionId: sessionStorage.getItem('exhibitionId'),
      exhibitionsList: [],
      exhibitionsListBoth: [],
      isShowCreateExhibitions: false,
      exhibitionsItemList: [],
      selectItem: '',
      selectExhibitionsItems: [],
      isAllowCreateExnum: false,
      searchTime: ''
    }
  },
  mounted() {
    this.getExhibitorsType()
    this.allowAddBooth()
  },
  methods: {
    search(name) {
      clearTimeout(this.searchTime)
      this.searchTime = setTimeout(() => {
        this.exhibitionsList = []
        this.getExhibitionsList(name)
      }, 500)
    },
    retrievalStr(text, retrieval) {
      var str = new RegExp(retrieval)
      return !str.test(text)
    },
    getExhibitionsList(name) {
      if (name) {
        const selectItem = []
        this.exhibitionsListBoth.map((item) => {
          if (!this.retrievalStr(item.exhibitor, name)) {
            selectItem.push(item)
          }
        })
        this.exhibitionsList = selectItem
      }
    },
    exhibitionsItemChange(list) {
      this.selectExhibitionsItems = list
    },
    handleChange(name) {
      const selectItem = this.exhibitionsList.filter(item => item.exhibitor === name)
      this.selectItem = selectItem[0].exhibitor
      this.isShowCreateExhibitions = true
      this.getExhibitorsItem(selectItem[0].exhibitor)
    },
    getExhibitorsItem(value = null) {
      const params = { expoid: this.exhibitionId, exhibitor: value, exnum: '', hallId: '', isEnable: 'YES' }
      this.$http.post(this.api + 'a/api/booth/page/bind', params).then(res => {
        this.exhibitionsItemList = res.data.data.list.map(item => {
          return { exnum: item.exnum, id: item.id, bind: item.bind }
        })
      })
    },
    getExhibitorsType() {
      this.$http.get(this.api + 'a/api/project/booth/exhibitor?exhibitionId=' + this.exhibitionId).then(res => {
        this.exhibitionsListBoth = res.data.data.list.filter(item => item !== null)
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getExhibitionsItemList() {
      return this.selectExhibitionsItems
    },
    // 是否允许新增展位
    allowAddBooth() {
      this.$http({
        method: 'get',
        url: `${this.api}a/api/exhibitionConfig/get?expoid=${this.exhibitionId}&&configType=CREATE_EXNUM`
      }).then(res => {
        if (res.data.resultCode === 0 || res.data.resultCode === '0') {
          const data = res.data.data.expoConfigs
          if (data.length > 0) {
            if (data[0].configValue === '0') {
              this.isAllowCreateExnum = true
            } else {
              this.isAllowCreateExnum = false
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.exhibitors-add{
  .mt-20{
    margin-top: 20px;
  }
  .mr-10{
    margin-right:10px;
  }
  .mb-16{
    margin-bottom:16px;
  }
  .flex{
    display: flex;
  }
  .red {
      color: #d10100;
      cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/fee/UseBooth/ExhibitorsAdd.vue